import { getSessionItem } from "./session";


/**
 * Returns the user's timezone offset (e.g. "-03:00")
 * extracted from sessionStorage User.timezone
 *
 * Expected format:
 * "America/Sao_Paulo -03:00"
 *
 * @returns {string} timezone offset or "+00:00" as fallback
 */
export const getUserTimezoneOffset = () => {
  const user = getSessionItem("User");
  if (!user?.timezone || typeof user.timezone !== "string") {
    return "+00:00";
  }

  const parts = user.timezone.split(" ");

  return parts[1] ?? "+00:00";
};
